// Build trigger comment
import { initSentry } from './lib/sentry';
import { initAnalytics, initPageEvents } from './lib/analytics';
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'
import { AuthProvider } from './context/AuthContext'
import { LocaleProvider } from './i18n/LocaleProvider'
import { ConsentProvider } from './components/providers/ConsentProvider'
import { CompanyProvider } from './contexts/CompanyContext'
import { FeedbackContextProvider } from './contexts/FeedbackContext'
import { Toaster } from './components/ui/sonner'
import { ShowAndTellProvider } from './components/feedback/showAndTell/ShowAndTellProvider'
import { RecordingControl } from './components/feedback/showAndTell/RecordingControl'
import { ModalFeedbackLauncher } from './components/feedback/showAndTell/ModalFeedbackLauncher'

initSentry();
initAnalytics();
initPageEvents();

const queryClient = new QueryClient()

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LocaleProvider>
          <CompanyProvider>
            <ConsentProvider>
              {/* FIN-869: wraps every route so a page (e.g. Transactions.tsx) can register
                  page-contributed feedback context regardless of which layout renders it. */}
              <FeedbackContextProvider>
                {/* FIN-1533: one recorder for the whole app, so a recording survives switching
                    between the platform-admin view and a company view. Off unless
                    VITE_SHOW_TELL_ENABLED is "true". */}
                <ShowAndTellProvider>
                  <App />
                  <RecordingControl />
                  <ModalFeedbackLauncher />
                </ShowAndTellProvider>
                <Toaster />
              </FeedbackContextProvider>
            </ConsentProvider>
          </CompanyProvider>
        </LocaleProvider>
      </AuthProvider>
    </QueryClientProvider>
  </BrowserRouter>
);
